import { includes } from 'lodash'

const geoPrepositionExceptions = [
  'Gotland',
  'Ekerö',
  'Lindingö',
  'Öland',
  'Orust',
  'Öckerö',
  'Tjörn',
]

export const adLocationPreposition = (name) => {
  if (!name) return ''

  return includes(geoPrepositionExceptions, name) ? `på ${name} ` : `i ${name} `
}
